/**
 * Display names for the `partId` vocabulary the model factories tag geometry with.
 *
 * `t` is optional because two callers have no translator to give: the drag ghost builds its
 * label outside React, and the module is re-exported from index.js for consumers that only
 * want the English form. Every on-screen call site passes one — without it the label silently
 * renders English, which is the bug this signature exists to make visible.
 */
const P = 'machineDashboard.digitalTwinExperience.threeD.partLabel';

export const PART_LABEL_OVERRIDES = {
  rear_end: 'Free End',
};

export function formatPartLabel(partId, t) {
  if (!partId) return null;
  const fallback = PART_LABEL_OVERRIDES[partId]
    || partId
      .split('_')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  if (!t) return fallback;
  return t(`${P}.${partId}`, { defaultValue: fallback });
}
